var exports = {
  "I": "SegmentedControl__GioqBZ",
};

module.exports = exports;
